import { connect } from 'react-redux';
import SiteStages from './siteStages';
import { bindActionCreators } from 'redux';
import { getSiteStage,siteStageStatus,siteUnhold,siteDismantle,saveSiteIssues,getIssuesList } from 'services/redux/installation/siteStages/action';
import { getCurrentLocation } from 'services/redux/sales/currentLocation/action';
import {
  getCheckLocation
} from "services/redux/installation/siteInspection/action";
import {getSiteData, calculateDistance, getDistanceDataDailyTaskAtt, getDistanceData, refreshAfterSiteCheckout} from "../../../services/redux/DistanceCalculator/action";
import { getProfile } from 'services/redux/auth/login/action';
import siteStageReducer from "../../../services/redux/installation/siteStages/reducer";

const mapStateToProps = (state) => ({
  siteStageData: state.siteStageReducer.siteStageData.site_stages,
  receivedAmount: state.siteStageReducer.siteStageData.received_amount,
  siteDetails: state.siteStageReducer.siteStageData.site_details,
  isVendorAllocated: state.siteStageReducer.siteStageData.is_vendor_allocated,
  locationCheck : state.siteInspectionReducer.locationCheck,
  userProfile : state.loginReducer.userProfile,
  siteData: state.leadDataReducer.siteData,
  dailyDistance: state.leadDataReducer.dailyDistance,
  distanceDetails: state.leadDataReducer.distanceDetails,
  engDistanceData: state.leadDataReducer.engDistanceData,
  issuesList: state.siteStageReducer.siteIssuesList,
  infraProjectId: state.siteStageReducer.siteStageData.infra_project_id,
  isCarnivalScheduled: state.siteStageReducer.siteStageData.isCarnivalScheduled,
  siteStageDetails: state.siteStageReducer.siteStageData,
  activeDistanceCheckin: state.loginReducer?.userProfile?.active_distance_checkin || null,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteStage,
      siteStageStatus,
      siteUnhold,
      siteDismantle,
      // getCurrentLocation,
      getCheckLocation,
      getSiteData,
      calculateDistance,
      getDistanceDataDailyTaskAtt,
      getDistanceData,
      refreshAfterSiteCheckout,
      saveSiteIssues,
      getIssuesList,
      getProfile,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteStages);
